export  const getTextContentByName = (name) => {
    const element = document.querySelector(`[name="${name}"]`);
    if (!element || !element.previousSibling || !element.previousSibling.parentNode) {
        throw new Error(`Elemento con name="${name}" no encontrado o inválido.`);
    }
    return element.previousSibling.parentNode.textContent;
};